import { organizationClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const authClient = createAuthClient({
	baseURL: import.meta.env.PUBLIC_API_URL,
	fetchOptions: {
		credentials: 'include',
	},
	plugins: [organizationClient()],
});

export const { signUp, signIn, signOut, useSession, getSession, organization } = authClient;
